import assets from 'shared/assets';
import styled from 'styled-components';

const DoctorContainer = styled.div` 
  width: 90%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  background: url(${assets.doctor}) no-repeat center bottom;
  background-size: contain;
  transform: translate(-55%, 20%);
`;

export default DoctorContainer;